import NavbarRegister from "./components/navbarRegister";
import SectionSix from "./components/sectionSix";
import Footer from "src/landingPages/components/Footer";

function LandingPageOneRegister() {
  return (
    <div id="landingPageOne" className="registerPageLayout">
      <NavbarRegister />
      <div className="registerPageWrapper">
        <SectionSix />
      </div>
      <Footer />
    </div>
  );
}

export default LandingPageOneRegister;
